module.exports = __webpack_public_path__ + "static/media/kitchen-dark.f8834ce6.jpg";